import { createFileRoute, redirect } from '@tanstack/react-router'
import { z } from 'zod'
import { Login } from '../../pages'
import useAuthStore from '../../stores/useAuthStore/useAuthStore'

const searchSchema = z.object({
    redirectTo: z.string().optional(),
})

export const Route = createFileRoute('/login/')({
    beforeLoad: () => {
        const { accessToken, sessionId } = useAuthStore.getState()

        if (accessToken && sessionId) {
            redirect({ to: '/', throw: true })
        }
        return true
    },
    component: () => <Login />,
    validateSearch: searchSchema,
})
